<!-- 修改积分 -->
<template>
   <div class="page_content">
      <!-- 会员信息卡片 -->
      <el-card class="member-card" body-style="padding: 10px;">
         <div slot="header" class="clearfix">
            <span class="card-title">会员信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="clearMember">清空</el-button>
         </div>
         <div class="member-info">
            <el-form :inline="true" size="small" @submit.native.prevent="searchMember">
               <el-form-item label="会员搜索:">
                  <el-input v-model="memberSearchText" placeholder="请输入手机号/姓名/卡号" clearable @keyup.enter.native="searchMember" style="width: 250px;">
                     <el-button slot="append" icon="el-icon-search" @click="searchMember"></el-button>
                  </el-input>
               </el-form-item>
            </el-form>

            <div v-if="selectedMember.memId" class="member-detail" style="margin-top: 10px;">
               <el-row :gutter="15" style="margin-bottom: 8px;">
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">会员姓名:</span>
                        <span class="value">{{ selectedMember.name }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">手机号码:</span>
                        <span class="value">{{ selectedMember.phone }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">当前积分:</span>
                        <span class="value points">{{ selectedMember.points }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">储值余额:</span>
                        <span class="value">{{ selectedMember.storedBalance }}</span>
                     </div>
                  </el-col>
               </el-row>
               <el-row :gutter="15">
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">会员卡号:</span>
                        <span class="value">{{ selectedMember.cardNo }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">卡类型:</span>
                        <span class="value">{{ selectedMember.cardType }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">注册门店:</span>
                        <span class="value">{{ selectedMember.registerStore }}</span>
                     </div>
                  </el-col>
                  <el-col :span="6">
                     <div class="member-item">
                        <span class="label">身份证号:</span>
                        <span class="value">{{ selectedMember.idCard }}</span>
                     </div>
                  </el-col>
               </el-row>
            </div>

            <div v-else class="no-member">
               <i class="el-icon-user"></i>
               <span>请先搜索并选择会员</span>
            </div>
         </div>
      </el-card>

      <!-- 积分修改区域 -->
      <el-card class="points-edit-card" style="margin-top: 5px;" body-style="padding: 20px;">
         <div slot="header" class="clearfix">
            <span class="card-title">积分修改</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="resetPointsEdit">重置</el-button>
         </div>

         <div class="points-edit-form" v-if="selectedMember.memId">
            <el-form :model="pointsForm" :rules="pointsRules" ref="pointsFormRef" label-width="120px" size="medium"  :show-message="false">
               <el-row :gutter="20">
                  <el-col :span="12">
                     <el-form-item label="当前积分:" prop="currentPoints">
                        <el-input v-model="pointsForm.currentPoints" disabled>
                           <template slot="prepend">
                              <i class="el-icon-coin"></i>
                           </template>
                        </el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="12">
                     <el-form-item label="修改类型:" prop="changeType">
                        <el-select v-model="pointsForm.changeType" placeholder="请选择修改类型" @change="onChangeTypeChange">
                           <el-option label="增加积分" value="add" />
                           <el-option label="减少积分" value="subtract" />
                        </el-select>
                     </el-form-item>
                  </el-col>
               </el-row>

               <el-row :gutter="20">
                  <el-col :span="12">
                     <el-form-item label="积分变动:" prop="changeAmount">
                        <el-input 
                           v-model="pointsForm.changeAmount" 
                           :min="pointsForm.changeType === 'subtract' ? -selectedMember.points : undefined"
                           :max="pointsForm.changeType === 'subtract' ? selectedMember.points : undefined"
                           :precision="0"
                           type="number"
                           controls-position="right"
                           placeholder="请输入积分数量"
                           style="width: 100%"
                           @change="calculateNewPoints">
                           
                        </el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="12">
                     <el-form-item label="修改后积分:">
                        <el-input v-model="calculatedNewPoints" disabled>
                           <template slot="prepend">
                              <i class="el-icon-trophy"></i>
                           </template>
                        </el-input>
                     </el-form-item>
                  </el-col>
               </el-row>

   

               <el-form-item label="备注说明:" prop="remark">
                  <el-input 
                     v-model="pointsForm.remark" 
                     type="textarea" 
                     :rows="3" 
                     placeholder="请输入详细的修改说明"
                     maxlength="200"
                     show-word-limit>
                  </el-input>
               </el-form-item>
            </el-form>

            <!-- 修改预览 -->
            <div class="points-preview" v-if="pointsForm.changeAmount !== null && pointsForm.changeAmount !== ''">
               <el-alert 
                  :title="getPreviewTitle()" 
                  :type="getPreviewType()" 
                  :closable="false"
                  show-icon>
                  <div slot="default">
                     <p><strong>会员：</strong>{{ selectedMember.name }} ({{ selectedMember.phone }})</p>
                     <p><strong>当前积分：</strong>{{ selectedMember.points }}</p>
                     <p><strong>{{ getChangeDescription() }}：</strong>{{ Math.abs(pointsForm.changeAmount) }}</p>
                     <p><strong>修改后积分：</strong>{{ calculatedNewPoints }}</p>
                  </div>
               </el-alert>
            </div>

            <!-- 操作按钮 -->
            <div class="points-actions" style="margin-top: 20px; text-align: center;">
               <el-button type="primary" size="medium" :disabled="!canModifyPoints" @click="confirmModifyPoints" :loading="modifyLoading">
                  <i class="el-icon-edit"></i>
                  确认修改积分
               </el-button>
               <el-button size="medium" @click="resetPointsEdit">重置</el-button>
            </div>
         </div>

         <div v-else class="no-member-selected">
            <i class="el-icon-warning"></i>
            <span>请先选择要修改积分的会员</span>
         </div>
      </el-card>

      <!-- 会员搜索弹窗 -->
      <el-dialog title="选择会员" :visible.sync="memberDialogVisible" width="80%" @open="handleMemberDialogOpen" @close="handleMemberDialogClose">
         <el-table 
            ref="memberTable"
            :data="memberList" 
            @row-click="handleRowClick" 
            @row-dblclick="selectMember" 
            highlight-current-row 
            style="cursor: pointer;"
            :current-row-key="currentSelectedMember ? currentSelectedMember.memId : null"
            row-key="memId"
            @keydown.native="handleTableKeyDown"
            tabindex="0">
            <el-table-column prop="cardNo" label="会员卡号" width="120" />
            <el-table-column prop="cardType" label="卡类型" width="100" />
            <el-table-column prop="name" label="姓名" width="100" />
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column prop="idCard" label="身份证号" min-width="160" />
            <el-table-column prop="registerStore" label="注册门店" width="120" />
            <el-table-column prop="pointBalance" label="积分余额" width="100" align="center" />
            <el-table-column prop="storedBalance" label="储值余额" width="100" align="center" />
         </el-table>
         <div slot="footer" class="dialog-footer">
            <el-button @click="closeMemberDialog">取消</el-button>
            <el-button type="primary" @click="confirmSelectMember" :disabled="!currentSelectedMember">确认选择</el-button>
         </div>
      </el-dialog>

      <!-- 积分修改确认弹窗 -->
      <el-dialog title="确认修改积分" :visible.sync="confirmDialogVisible" width="50%">
         <div class="confirm-content">
            <div class="confirm-member">
               <h4>会员信息:</h4>
               <p>姓名: {{ selectedMember.name }} | 手机: {{ selectedMember.phone }} | 当前积分: {{ selectedMember.points }}</p>
            </div>

            <div class="confirm-change">
               <h4>积分修改详情:</h4>
               <el-table :data="[pointsForm]" border size="small">
                  <el-table-column prop="changeType" label="修改类型" width="120">
                     <template slot-scope="scope">
                        <el-tag :type="scope.row.changeType === 'add' ? 'success' : (scope.row.changeType === 'subtract' ? 'danger' : 'warning')">
                           {{ scope.row.changeType === 'add' ? '增加积分' : (scope.row.changeType === 'subtract' ? '减少积分' : '设置积分') }}
                        </el-tag>
                     </template>
                  </el-table-column>
                  <el-table-column prop="changeAmount" label="变动数量" width="120" align="center">
                     <template slot-scope="scope">
                        <span :style="{ color: scope.row.changeType === 'add' ? '#67c23a' : (scope.row.changeType === 'subtract' ? '#f56c6c' : '#e6a23c') }">
                           {{ scope.row.changeType === 'add' ? '+' : (scope.row.changeType === 'subtract' ? '-' : '') }}{{ Math.abs(scope.row.changeAmount) }}
                        </span>
                     </template>
                  </el-table-column>

                  <el-table-column prop="remark" label="备注说明" min-width="200" show-overflow-tooltip />
               </el-table>
            </div>

            <div class="confirm-summary">
               <el-row :gutter="20" style="margin-top: 15px;">
                  <el-col :span="8">
                     <div class="summary-box">
                        <div class="summary-label">当前积分</div>
                        <div class="summary-value">{{ selectedMember.points }}</div>
                     </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="summary-box">
                        <div class="summary-label">{{ getChangeDescription() }}</div>
                        <div class="summary-value" :style="{ color: pointsForm.changeType === 'add' ? '#67c23a' : '#f56c6c' }">
                           {{ pointsForm.changeType === 'add' ? '+' : (pointsForm.changeType === 'subtract' ? '-' : '') }}{{ Math.abs(pointsForm.changeAmount) }}
                        </div>
                     </div>
                  </el-col>
                  <el-col :span="8">
                     <div class="summary-box">
                        <div class="summary-label">修改后积分</div>
                        <div class="summary-value final-points">{{ calculatedNewPoints }}</div>
                     </div>
                  </el-col>
               </el-row>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="confirmDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="executePointsModify" :loading="modifyLoading">确认修改</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         // 会员相关
         memberSearchText: '',
         selectedMember: {
            memId: null,
            name: '',
            phone: '',
            idCard: '',
            points: 0,
            registerStore: '',
            pointBalance: 0,
            storedBalance: 0,
            cardNo: '',
            cardType: '',
      
         },
         memberList: [],
         memberDialogVisible: false,
         currentSelectedMember: null, // 当前选中的会员（用于单击选中）
         currentMemberIndex: 0, // 当前选中的会员索引

         // 积分修改相关
         pointsForm: {
            currentPoints: 0,
            changeType: '', // add, subtract, set
            changeAmount: null,
     
            remark: ''
         },
         calculatedNewPoints: 0,
         confirmDialogVisible: false,
         modifyLoading: false,
         storeId: ''
      }
   },

   computed: {
      // 表单验证规则
      pointsRules() {
         return {
            changeType: [
               { required: true, message: '请选择修改类型', trigger: 'change' }
            ],
            changeAmount: [
               { required: true, message: '请输入积分变动数量', trigger: 'blur' },

            ],
        
         };
      },
      // 是否可以修改积分
      canModifyPoints() {
         return this.selectedMember.memId &&
            this.pointsForm.changeType &&
            this.pointsForm.changeAmount !== null &&
            this.pointsForm.changeAmount !== '' 
      }
   },
   created() {
       this.$http.storemastGetCurStore().then(res => {
             if (res.status == 200) {
                this.storeId = res.result.storeId
          
             }
          })
   },
   methods: {
      // 积分修改相关方法
      // 修改类型变化时的处理
      onChangeTypeChange() {
         this.pointsForm.changeAmount = null;
         this.calculatedNewPoints = this.selectedMember.points;
      },

      // 计算修改后的积分
      calculateNewPoints() {
         if (this.pointsForm.changeAmount === null || this.pointsForm.changeAmount === '') {
            this.calculatedNewPoints = this.selectedMember.points;
            return;
         }

         const currentPoints = this.selectedMember.points;
         const changeAmount = this.pointsForm.changeAmount;

         switch (this.pointsForm.changeType) {
            case 'add':
               this.calculatedNewPoints = Number(currentPoints) + Number(changeAmount);
               break;
            case 'subtract':
               this.calculatedNewPoints = Math.max(0, currentPoints - changeAmount);
               break;
            case 'set':
               this.calculatedNewPoints = changeAmount;
               break;
            default:
               this.calculatedNewPoints = currentPoints;
         }
      },

      // 获取预览标题
      getPreviewTitle() {
         switch (this.pointsForm.changeType) {
            case 'add':
               return '积分增加预览';
            case 'subtract':
               return '积分减少预览';
            case 'set':
               return '积分设置预览';
            default:
               return '积分修改预览';
         }
      },

      // 获取预览类型
      getPreviewType() {
         switch (this.pointsForm.changeType) {
            case 'add':
               return 'success';
            case 'subtract':
               return 'warning';
            case 'set':
               return 'info';
            default:
               return 'info';
         }
      },

      // 获取变动描述
      getChangeDescription() {
         switch (this.pointsForm.changeType) {
            case 'add':
               return '增加积分';
            case 'subtract':
               return '减少积分';
            case 'set':
               return '设置积分';
            default:
               return '积分变动';
         }
      },

      // 重置积分编辑
      resetPointsEdit() {
         this.pointsForm = {
            currentPoints: this.selectedMember.points || 0,
            changeType: '',
            changeAmount: null,
      
            remark: ''
         };
         this.calculatedNewPoints = this.selectedMember.points || 0;
         
         // 清除表单验证
         if (this.$refs.pointsFormRef) {
            this.$refs.pointsFormRef.clearValidate();
         }
      },

      // 确认修改积分
      confirmModifyPoints() {
         this.$refs.pointsFormRef.validate((valid) => {
            if (valid) {
               this.confirmDialogVisible = true;
            } else {
               this.$message.error('请完善表单信息');
            }
         });
      },

      // 执行积分修改
      async executePointsModify() {
         this.modifyLoading = true;

         try {
            // 计算实际的积分变动值
            let actualChangeAmount = 0;
            switch (this.pointsForm.changeType) {
               case 'add':
                  actualChangeAmount = this.pointsForm.changeAmount;
                  break;
               case 'subtract':
                  actualChangeAmount = -this.pointsForm.changeAmount;
                  break;
               case 'set':
                  actualChangeAmount = this.pointsForm.changeAmount - this.selectedMember.points;
                  break;
            }

            const response = await this.$http.memRedeemPointChange({
               memId: this.selectedMember.memId,
               costPoint: actualChangeAmount,
               remark: this.pointsForm.remark,
               storeId: this.storeId
            });

            if (response.status === 200) {
               this.$message.success('积分修改成功！');
               
               // 更新会员积分显示
               this.selectedMember.points = this.calculatedNewPoints;
               this.pointsForm.currentPoints = this.calculatedNewPoints;
               
               this.confirmDialogVisible = false;
               this.resetPointsEdit();
            } else {
               this.$message.error(response.message || '积分修改失败');
            }
         } catch (error) {
            console.error('积分修改失败:', error);
            this.$message.error('积分修改失败，请重试');
         } finally {
            this.modifyLoading = false;
         }
      },
      // 搜索会员
      async searchMember() {
         if (!this.memberSearchText.trim()) {
            this.$message.warning('请输入搜索关键词');
            return;
         }

         try {
            // 调用会员查询API
            const response = await this.$http.memberDeskQueryMem({
               keyWord: this.memberSearchText, // 手机号搜索
             
            });

            // 映射API返回的字段到弹窗显示的字段
            const mappedList = response.result.list.map(member => ({
               cardNo: member.cardCode || '',
               cardType: member.capName || '',
               name: member.memName || '',
               phone: member.memPhone || '',
               idCard: member.memIdcard || '',
               points: member.pointBalance || 0,
               registerStore: member.storeName || '',
               pointBalance: member.pointBalance || 0,
               storedBalance: member.storedBalance || 0,
               memId: member.memId || '', // 添加会员ID
             
            }));

            if (mappedList.length === 1) {
               // 如果只有一个结果，直接选择
               this.selectMember(mappedList[0]);
            } else if (mappedList.length > 1) {
               // 多个结果，显示选择弹窗
               this.memberList = mappedList;
               this.memberDialogVisible = true;
               // 默认选中第一条记录
               this.currentMemberIndex = 0;
               this.$nextTick(() => {
                  if (this.memberList.length > 0) {
                     this.currentSelectedMember = this.memberList[0];
                     this.$refs.memberTable.setCurrentRow(this.memberList[0]);
                  }
               });
            }
         } catch (error) {
            this.$message.error('搜索会员失败');
         }
      },

      // 处理单击选中行
      handleRowClick(row) {
         this.currentSelectedMember = row;
      },

      // 确认选择会员（按钮点击）
      confirmSelectMember() {
         if (this.currentSelectedMember) {
            this.selectMember(this.currentSelectedMember);
         }
      },

      // 关闭会员选择弹窗
      closeMemberDialog() {
         this.memberDialogVisible = false;
         this.currentSelectedMember = null;
         this.currentMemberIndex = 0;
      },

      // 会员弹窗打开事件
      handleMemberDialogOpen() {
         this.$nextTick(() => {
            // 聚焦到表格
            if (this.$refs.memberTable) {
               this.$refs.memberTable.$el.focus();
            }
            // 默认选中第一条记录
            if (this.memberList.length > 0) {
               this.currentMemberIndex = 0;
               this.currentSelectedMember = this.memberList[0];
               this.$refs.memberTable.setCurrentRow(this.memberList[0]);
            }
         });
      },

      // 会员弹窗关闭事件
      handleMemberDialogClose() {
         this.currentSelectedMember = null;
         this.currentMemberIndex = 0;
      },

      // 处理表格键盘事件
      handleTableKeyDown(event) {
         if (this.memberList.length === 0) return;

         switch (event.key) {
            case 'ArrowDown':
               event.preventDefault();
               this.currentMemberIndex = Math.min(this.currentMemberIndex + 1, this.memberList.length - 1);
               this.selectCurrentMember();
               break;
            case 'ArrowUp':
               event.preventDefault();
               this.currentMemberIndex = Math.max(this.currentMemberIndex - 1, 0);
               this.selectCurrentMember();
               break;
            case 'Enter':
               event.preventDefault();
               if (this.currentSelectedMember) {
                  this.selectMember(this.currentSelectedMember);
               }
               break;
            case 'Escape':
               event.preventDefault();
               this.closeMemberDialog();
               break;
         }
      },

      // 选中当前索引的会员
      selectCurrentMember() {
         if (this.memberList[this.currentMemberIndex]) {
            this.currentSelectedMember = this.memberList[this.currentMemberIndex];
            this.$refs.memberTable.setCurrentRow(this.memberList[this.currentMemberIndex]);
         }
      },

      // 选择会员
      selectMember(member) {
         this.selectedMember = {
            ...member,
            points: member.pointBalance || member.memPointbalance || 0  // 确保积分字段正确
         };
         this.memberDialogVisible = false;
         this.currentSelectedMember = null; // 重置当前选中状态
         this.memberSearchText = `${member.name} (${member.phone})`;
         
         // 初始化积分表单
         this.pointsForm.currentPoints = this.selectedMember.points;
         this.calculatedNewPoints = this.selectedMember.points;
      },

      // 清空会员
      clearMember() {
         this.selectedMember = {};
         this.memberSearchText = '';
         this.resetPointsEdit();
      },








   },


}
</script>

<style scoped>
.page_content {
   padding: 5px;
   background-color: #f5f5f5;
   min-height: 100vh;
}

.card-title {
   font-size: 16px;
   font-weight: bold;
   color: #303133;
}

.member-info {
   min-height: 100px;
}

.member-detail {
   margin-top: 15px;
   padding: 12px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.member-item {
   margin-bottom: 8px;
}

.member-item .label {
   color: #606266;
   margin-right: 8px;
}

.member-item .value {
   color: #303133;
   font-weight: 500;
}

.member-item .points {
   color: #e6a23c;
   font-size: 18px;
   font-weight: bold;
}

.no-member {
   text-align: center;
   padding: 30px;
   color: #909399;
}

.no-member i {
   font-size: 40px;
   margin-bottom: 8px;
   display: block;
}

.gift-search {
   margin-bottom: 15px;
}

.summary-item {
   text-align: center;
}

.summary-item .value {
   font-size: 18px;
   font-weight: bold;
   color: #303133;
}

.summary-item .total-points {
   color: #e6a23c;
}

.summary-item .remaining-points {
   color: #67c23a;
}

.selected-gifts {
   margin-top: 20px;
}

.selected-gifts h4 {
   margin-bottom: 10px;
   color: #303133;
}

.exchange-actions {
   border-top: 1px solid #ebeef5;
   padding-top: 15px;
}

.confirm-content {
   padding: 20px;
}

.confirm-member,
.confirm-gifts,
.confirm-summary {
   margin-bottom: 20px;
}

.confirm-gifts ul {
   list-style-type: none;
   padding: 0;
}

.confirm-gifts li {
   padding: 5px 0;
   border-bottom: 1px solid #ebeef5;
}

.confirm-summary p {
   font-size: 16px;
   margin: 10px 0;
}

/* 积分修改相关样式 */
.points-edit-form {
   padding: 10px 0;
}

.points-preview {
   margin-top: 20px;
}

.no-member-selected {
   text-align: center;
   padding: 40px;
   color: #909399;
}

.no-member-selected i {
   font-size: 48px;
   margin-bottom: 12px;
   display: block;
}

.summary-box {
   text-align: center;
   padding: 15px;
   background: #f8f9fa;
   border-radius: 6px;
   border: 1px solid #e9ecef;
}

.summary-label {
   font-size: 14px;
   color: #606266;
   margin-bottom: 8px;
}

.summary-value {
   font-size: 20px;
   font-weight: bold;
   color: #303133;
}

.final-points {
   color: #409eff !important;
}

/* 表单样式优化 */
.points-edit-card .el-form-item__label {
   font-weight: 500;
   color: #606266;
}

.points-edit-card .el-input-number {
   width: 100%;
}

.points-edit-card .el-input-number .el-input__inner {
   text-align: left;
}

/* 确认弹窗样式 */
.confirm-change {
   margin: 20px 0;
}

.confirm-change h4 {
   margin-bottom: 15px;
   color: #303133;
   font-size: 16px;
}
</style>
